import styled from 'styled-components';

export interface IProps {
  isViewMode: boolean; // 세팅화면인지/뷰화면인지 여부
}

const SiteDashboardStyle = styled.div<IProps>`
  height: 100%;

  * {
    user-select: none;
  }

  .dragNDropZone {
    display: flex;
    justify-content: space-between;
    align-items: start;
    height: 100%;
    .dragZone {
      display: ${(props) => (props.isViewMode ? `none !important` : `flex`)};
      flex: 0.15;
      display: flex;
      flex-direction: column;
      .dragCell {
        margin: 0.5rem 0;
      }
    }

    .dropZone {
      height: 100%;
      flex: ${(props) => (props.isViewMode ? `1` : `0.85`)};
      display: grid !important;
      grid-template-columns: repeat(5, 1fr);
      grid-template-rows: repeat(8, 1fr);
      gap: 1rem;

      > div {
        margin: 0;
        background-color: var(--widget-bg);
        overflow: hidden;
      }
    }
  }

  /* @media screen and (max-width: 1024px) {
    .dragNDropZone .dropZone {
      grid-template-columns: repeat(1, 1fr);
    }
  } */
`;

const DraggableCellStyle = styled.div`
  // min-width: min-content;
  background-color: #5ac8fa;
  color: #fff;
  padding: 0.5rem;
  border-radius: 5px;
  text-align: center;
  margin-bottom: 1rem;
  cursor: pointer;
  opacity: '1';
  height: 90%;
`;

const DroppableCellStyle = styled.div<IProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* min-height: 100px; */
  height: 100%;
  border-radius: 1.875rem;
  .dropCell {
    width: 100%;
    height: 100%;
  }
  .closeIconWrapper {
    display: ${(props) => (props.isViewMode ? `none !important` : `flex`)};
  }
`;

const ControlStyle = styled.div`
  height: inherit;
  position: relative;
  --ck-color-base-background: var(--widget-bg);
  --ck-color-dropdown-panel-background: var(--widget-bg);
  --ck-color-split-button-hover-background: var(--widget-bg);

  // 상황판 스크롤 숨기기
  & ::-webkit-scrollbar {
    display: none;
  }

  .widget-title > span {
    flex-shrink: 0;
    font-weight: var(--font-semibold);
    font-size: 1.125rem;
    line-height: 1.2;
    color: var(--text-primary);
    display: flex;
    align-items: center;
    > .badge {
      font-weight: 500;
      font-size: 0.875rem;
      padding: 0.125rem 0.5rem;
      border-radius: 0.25rem;
      background-color: var(--widget-theme-tonal-blue);
      margin: 0 0.5rem;
      color: var(--widget-primary);
      display: inline-block;
      min-width: 1.75rem;
      text-align: center;
    }
  }

  .weatherTodayInfo,
  .weatherWeekInfo {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .weatherError {
      position: absolute;
      justify-content: center;
      align-items: center;
      z-index: 10;
      width: 100%;
      top: 0;
      > div {
        width: inherit;
        border-radius: 0.5rem 0.5rem 0 0;

        > p {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.25rem;
          width: inherit;
          padding: 0.25rem 0;
          color: #fff;
          background-color: rgba(0, 0, 0, 0.4);
          border-radius: 0;

          > span.material-symbols-rounded {
            font-size: 20px;
          }
        }
      }
    }

    > .widget-half-background {
      background-color: #3e97ff;
      position: absolute;
      top: 0;
      border-radius: 0.5rem;
      width: 100%;
      height: 50%;
    }
    > .widget-header {
      position: absolute;
      top: 0;
      width: 100%;
      padding: 0.75rem 1rem;
      z-index: 10;
      // background-color: var(--weather-bg);
      > .widget-title {
        // height: 2rem;
        color: white;
        > span {
          font-weight: 600;
          font-size: 1.125rem;
          line-height: 1.2;
        }
      }
      > .widget-subTitle {
      }
    }
    > .widget-body {
      width: 100%;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      /* overflow: hidden; */
      overflow: visible;
      z-index: 1;
      .weatherToday {
        position: relative;
        flex: 1 0 50%;
        width: 100%;
        max-height: 22rem;
        -webkit-box-pack: justify;
        justify-content: space-around;
        -webkit-box-align: center;
        align-items: center;
        background: var(--widget-primary);
        // background-color: var(--weather-bg);
        .weatherInfo {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          height: 100%;
          padding: 0 1.5rem;
          > div:nth-child(1) {
            font-weight: 500;
            font-size: 1.125rem;
          }

          .weather-icon {
            position: relative;
            left: 1rem;
          }
        }
        .weatherBox {
          height: 6rem;
          border-radius: 8px;
          padding: 0 1rem;
          text-align: center;
          background: #f3f6f9;
          font-size: 0.875rem;
          dt {
            font-weight: 500;
          }
          dl > div {
            display: flex;
            width: inherit;
            > dt,
            > dd {
              flex: 0.5;
            }
            > dt {
              text-align: start;
            }
            > dd {
              text-align: center;
            }
          }
        }
        .weatherBox.text {
          display: flex;
          flex-direction: column;
          justify-content: center;
          > div {
            display: flex;
            justify-content: space-between;
          }
        }
        .weatherAnimationWrapper {
          .container {
            > div {
              svg {
                pointer-events: none;
              }
            }
          }
        }
      }
      .weatherToday.notWeek .weatherInfo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 100%;
        z-index: 10;
        padding: 0 1.5rem;
        > div .weatherBox {
          height: auto;
          background-color: transparent;
          padding: 0;
          > div {
            justify-content: flex-start;
            gap: 0.5rem;
            height: 1.25rem;
          }
        }
      }
      .weatherWeek {
        flex: 1 0 50%;
        padding: 1.25rem 1rem;
        display: flex;
        background-color: var(--widget-bg);
        z-index: 999;
        > div {
          flex: 1;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          .date {
            display: flex;
            flex-direction: column;
            align-items: center;

            > div {
              font-size: 0.875rem;
              font-weight: 600;
            }
            > div:nth-child(1) {
              color: var(--text-secondary);
            }
            > div:nth-child(2) {
              color: var(--text-primary);
            }
          }
          .weatherWeekIcon {
            > img {
              width: 2.5rem;
            }

            > .no-weather-icon {
              display: flex;
              align-items: center;
              justify-content: center;
              color: var(--widget-text-primary);
            }
          }
          .weatherWeekTemp {
            > div {
              font-weight: 600;
              color: var(--text-secondary);
              font-size: 0.75rem;
            }
          }
        }
      }
      .weatherTodayDetail {
        height: 100%;
        background-color: var(--widget-bg);
        z-index: 10;
        .weatherBoxGroup {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 0.5rem;
          bottom: 1rem;
          position: absolute;
          width: calc(100% - 3rem);
          left: 50%;
          transform: translate(-50%, 0);
          .weatherBox {
            height: 6rem;
            border-radius: 8px;
            padding: 0 1rem;
            text-align: center;
            background: var(--widget-sub-bg);
            // background: var(--tonal);
            font-size: 0.875rem;
            dt,
            > div > dt,
            > div > dd {
              font-weight: 500;
              color: var(--text-primary);
            }

            dl > div {
              display: flex;
              width: inherit;
              > dt,
              > dd {
                flex: 0.5;
              }
              > dt {
                text-align: start;
              }
              > dd {
                text-align: center;
              }
            }
          }
          .weatherBox.text {
            display: flex;
            flex-direction: column;
            justify-content: center;
            > div {
              display: flex;
              justify-content: space-between;
            }
          }
          .weatherBox.icon {
            display: flex;
            align-items: center;
            justify-content: space-between;
            dt {
              text-align: left;
            }
            > dd {
              position: relative;
              > div:nth-child(1) img {
                height: 4rem;
              }
            }
            .weatherBox-details {
              display: flex;
              flex-direction: column;
              /* gap: 0.5rem; */
              justify-content: center;
              font-size: 0.75rem;
              > div {
                height: 1.25rem;
                font-weight: 600;
                color: var(--text-secondary);
              }
            }
          }
        }
      }
    }

    .contents {
      height: calc(100% - 4rem);
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      > div {
        flex: 0.5;
      }
    }

    .weatherAnimationWrapper {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: visible;

      .container {
        width: 100%;
        height: inherit;
        position: relative;

        .svg-container {
          left: 0;
        }
      }

      .rotating-sun {
        animation: rotation 10s infinite linear;
        position: absolute;
        top: -1.5rem;
        right: 3.5rem;
      }
      .little_cloud {
        position: absolute;
        right: 1%;
        top: -15%;
        &.beside-sun {
          right: 6%;
        }
      }
      .blur {
        position: absolute;
        right: 8%;
        top: -10%;
        width: 180px;
      }
      .cloudy {
        left: 25% !important;
        top: 17%;
      }
    }
  }

  .snowdrop {
    position: absolute;
    bottom: 0;
    width: 2px;
    height: 15px;
    background: transparent;
    opacity: 0.7;
    animation-name: snowfall;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    top: -20px;
  }

  @keyframes snowfall {
    0% {
      transform: translate3d(0, 0, 0);
    }
    25% {
      transform: translate3d(var(--random-left-right, 0), 25vh, 0);
    }
    50% {
      transform: translate3d(0, 50vh, 0);
    }
    75% {
      transform: translate3d(var(--random-left-right, 0), 75vh, 0);
    }
    100% {
      transform: translate3d(0, 100vh, 0);
    }
  }

  @keyframes fall {
    to {
      transform: translateY(100vh);
    }
  }

  .svg-container {
    position: absolute;
    top: 0;
    left: -100%;
    width: inherit;
    height: inherit;
    transition: left 1s ease-in-out;
  }

  .show-svg {
    left: 25%;
  }

  .floating {
    animation: float 3s ease-in-out infinite;
  }

  @keyframes float {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
    100% {
      transform: translateY(0);
    }
  }

  .bouncing {
    animation: bounce 4s ease infinite;
  }

  @keyframes bounce {
    0%,
    100% {
      transform: translateY(0);
    }
    14%,
    29% {
      transform: translateY(-20px);
    }
  }

  .raindrop,
  .snowice,
  .sunflower {
    position: absolute;
    bottom: 0;
    opacity: 0.7;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    top: -20px;
  }

  .raindrop {
    width: 2px;
    height: 15px;
    background: lightgray;
    animation-name: fallRaindrop;
  }

  .snowice {
    width: 10px;
    height: 10px;
    background: transparent;
    animation-name: fallSnowIce;
  }

  .sunflower {
    width: 15px;
    height: 15px;
    background: transparent;
    animation-name: fallSunflower;
  }

  @keyframes fallRaindrop {
    to {
      transform: translateY(100vh);
    }
  }

  @keyframes fallSnowIce {
    to {
      transform: translateY(100vh);
    }
  }

  @keyframes fallSunflower {
    to {
      transform: translateY(100vh);
    }
  }
  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    div.refresh-btn {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2rem;
      height: 2rem;
      border-radius: 2rem;
      .material-symbols-rounded {
        font-variation-settings: 'FILL' 1, 'wght' 300, 'GRAD' 0, 'opsz' 20;
        color: #78829d;
      }
    }
    div.refresh-btn:hover {
      background-color: #f1f1f2;
    }
    div.refresh-btn.white {
      .material-symbols-rounded {
        color: white;
        opacity: 0.6;
      }
    }
    div.refresh-btn.white:hover {
      .material-symbols-rounded {
        opacity: 1;
      }
    }
  }

  .stickyHeader {
    overflow: visible;
    > .widget-header {
      position: sticky;
      top: 0;
      z-index: 1;
      margin: 0 !important;
      padding: 0.75rem 0 !important;
    }
  }

  .dDay,
  .accidentInfo,
  .siteNote,
  .safetyViolationInfoDetail,
  .imageBoard,
  .noxiousGas,
  .excavationProcess,
  .mGas {
    user-select: none;
    height: 100%;
    > .widget-header {
      width: 100%;
      margin: 0.75rem 0;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      > .widget-title {
        padding: 0 1.5rem;
        height: 2rem;
        align-items: center;
        > span {
          font-weight: var(--font-semibold);
          font-size: var(--widget-font-size-title-sm);
          line-height: 1.2;
          color: var(--widget-text-primary);
          > .badge {
            font-weight: 500;
            font-size: 0.875rem;
            padding: 0.25rem 0.25rem;
            border-radius: 0.25rem;
            background-color: var(--widget-theme-tonal-blue);
            margin: 0 0.5rem;
            color: var(--widget-primary);
            display: inline-block;
            min-width: 1.5rem;
            text-align: center;
          }
        }
        > .widget-top-btn-wrap {
          display: flex;
          align-items: center;
          gap: 0.5rem;

          > .widget-btn-group {
            display: flex;
            gap: 0.5rem;
            align-items: center;
            > span {
              font-weight: var(--font-semibold);
              font-size: 1.125rem;
              color: var(--text-primary);
            }
            > button {
              height: 2rem;
              font-weight: var(--font-bold);
              padding: 0 0.75rem;
              border-radius: 1rem;
              font-size: 0.875rem;
              color: var(--text-secondary);
              background-color: var(--tonal);
              border-radius: 0.5rem;
              gap: 0;
            }
            > button:hover {
              background-color: var(--tonal);
            }
            > button:nth-child(1) {
              padding-left: 0.25rem;
              padding-right: 0.5rem;
              .material-symbols-rounded {
                font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 20;
                color: #78829d;
              }
            }
            > .innerTab {
              gap: 0.25rem;
              > div {
                cursor: pointer;
                height: 2rem;
                padding: 0 0.75rem;
                display: flex;
                align-items: center;
                font-weight: 500;
                color: var(--text-secondary);
                border-radius: 1rem;
                font-weight: var(--font-medium);
                /* font-size: 0.875rem; */
              }
              > div.active {
                font-weight: var(--font-bold);
                color: #3e97ff;
                background-color: var(--tonal);
              }
              > div:hover {
                background-color: var(--tonal);
              }
            }
          }
        }
        > .widget-title-innerTab,
        > .widget-btn-group {
          display: flex;
          gap: 0.5rem;
          align-items: center;
          > span {
            font-weight: var(--font-semibold);
            font-size: 1.125rem;
            color: var(--text-primary);
          }
          > button {
            height: 2rem;
            font-weight: var(--font-bold);
            padding: 0 0.75rem;
            border-radius: 1rem;
            font-size: 0.875rem;
            color: var(--text-secondary);
            background-color: var(--tonal);
            border-radius: 0.5rem;
            gap: 0;
          }
          > button:hover {
            background-color: var(--tonal);
          }
          > button:nth-child(1) {
            padding-left: 0.25rem;
            padding-right: 0.5rem;
            .material-symbols-rounded {
              font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 20;
              color: #78829d;
            }
          }
          > .innerTab {
            gap: 0.25rem;
            > div {
              cursor: pointer;
              height: 2rem;
              padding: 0 0.75rem;
              display: flex;
              align-items: center;
              font-weight: 500;
              color: var(--text-secondary);
              border-radius: 1rem;
              font-weight: var(--font-medium);
              /* font-size: 0.875rem; */
            }
            > div.active {
              font-weight: var(--font-bold);
              color: #3e97ff;
              background-color: var(--tonal);
            }
            > div:hover {
              background-color: var(--tonal);
            }
          }
        }
      }
    }
    > .widget-header.safety {
      gap: 0;
      > .widget-subTitle {
        font-size: 0.875rem;
        line-height: 1rem;
        color: var(--text-secondary);
        padding: 0 1.5rem;
      }
    }
    .oneWeekCalendar-wrapper {
      padding: 0 1rem;
      width: 100%;
    }
    .oneWeekCalendar {
      gap: 0.25rem;
      .dayWrapper {
        flex-grow: 1;
        padding: 0.75rem 0;
        max-width: 2.75rem;
        border-radius: 2rem;
        text-align: center;
        cursor: pointer;
        .day {
          font-weight: var(--font-medium);
          color: var(--text-tertiary);
        }
        .date {
          color: var(--text-primary);
        }
      }
      .todayHighlight {
        background-color: var(--selected-primary);
        > div.day,
        > div.date {
          color: #fff;
        }
        > div.day {
          font-weight: 500;
        }
      }
    }
    .widget-body {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .widget-body.safety {
      gap: 1rem;
      > div:nth-child(1) {
        background-color: rgb(255, 247, 237);
      }
    }
    .widget-body.note {
      width: 100%;
      height: 100%;
      .sliderWrapper {
        height: inherit;
        .slick-list .slick-track .slick-slide > div {
          padding: 0 1rem;
          th,
          td {
            border: 1px solid var(--outline);
          }
        }
        .ck-content {
          border: 1px solid lightgray;
          border-radius: 0.25rem;
          padding: 0.5rem;
          height: 7rem;
          overflow: hidden;
          > * {
            margin: 0;
          }
        }
        .slick-arrow {
          display: none !important;
        }
        .slick-dots {
          top: -2.25rem;
          width: inherit;
          right: 1rem;
          li {
            margin: 0;
            width: 24px;
            button {
              width: 1.5rem;
            }
            button:before {
              transition: all ease-in-out 0.2s;
              font-family: 'slick';
              font-size: 15px;
              line-height: 20px;
              position: absolute;
              top: 0;
              left: 0;
              /* width: 12px; */
              height: 6px;
              border-radius: 0.5rem;
              content: '';
              text-align: center;
              color: black;
              -webkit-font-smoothing: antialiased;
              -moz-osx-font-smoothing: grayscale;
              background-color: var(--widget-primary);
            }
          }
        }
        .noteTitle {
          padding-bottom: 0.5rem;
          > div:nth-child(1) > span:nth-child(2) {
            color: var(--text-primary);
          }
          > div:nth-child(2) {
            color: var(--text-secondary);
            font-size: 0.875rem;
          }
        }
        .ck-content {
          border: 1px solid var(--outline);
        }
        .ck-editor__editable {
          background-color: var(--board);
          background-color: var(--tonal);
          * {
            color: var(--text-primary);
          }
        }
        .titleBar {
          width: 0.125rem;
          height: 1rem;
          background-color: #2977ff;
          margin-right: 0.5rem;
        }
      }
    }
    .widget-body.photoTable {
      flex-grow: 1;
      overflow: hidden;
      > .innerTab {
        width: 100%;
        display: flex;
        border-bottom: 1px solid var(--outline);
        > div {
          height: 3rem;
          display: flex;
          align-items: center;
          flex: 1 1 50%;
          justify-content: center;
          border-bottom: 2px solid transparent;
          font-size: 0.875rem;
          cursor: pointer;
          color: var(--text-secondary);
          font-weight: 700;
        }
        > div.active {
          color: var(--text-primary);
          border-bottom: 2px solid var(--widget-primary);
        }
        .text-container .active {
          display: block;
          animation: slideIn 2s forwards;
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateX(-100%);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slide {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(-100%);
          }
        }
      }
      > .innerTab.nonClick > div {
        pointer-events: none;
        cursor: initial;
      }
      > .sliderWrapper {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        .text-container {
          display: flex;
          flex-direction: column;
          position: relative;
        }

        .rowWrapper {
          pointer-events: none;
          width: 100%;
          padding: 0 1.5rem;
          cursor: pointer;
          gap: 0.5rem;
          height: 3.5rem;
          > div:nth-child(1) {
            flex-grow: 1;
            gap: 0.5rem;
            width: 12rem;
            .imgWrapper {
              width: 2.25rem;
              height: 2.25rem;
              border-radius: 0.25rem;
              overflow: hidden;
              flex-shrink: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: rgba(0, 0, 0, 0.05);
              .material-symbols-rounded {
                font-variation-settings: 'FILL' 1, 'wght' 600, 'GRAD' 200, 'opsz' 48;
                color: rgba(0, 0, 0, 0.25);
                font-size: 1.75rem;
              }

              img {
                width: inherit;
                height: inherit;
                object-fit: cover;
              }
            }
            > div:nth-child(2) {
              width: calc(100% - 2.75rem);
              > div:nth-child(1),
              > .rowContent {
                width: 100%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                font-size: 0.875rem;
                line-height: 1.25rem;
                height: 1.25rem;
                color: var(--text-disabled);
                span {
                  color: var(--text-primary);
                  font-size: 0.875rem;
                  line-height: 1rem;
                }
              }
            }
          }
        }
        .buttonsWrapper {
          button {
            height: inherit;
            padding: 0;
            width: 2.5rem;
            font-size: 0.875rem;
            height: 1.75rem;
            span {
              font-weight: 700;
              margin: 0 0.125rem;
            }
          }
          button.red {
            background-color: var(--tonal-red);
            color: var(--filled-red);
          }
          button.amber {
            background-color: var(--tonal-orange);
            color: var(--filled-amber);
          }
        }
      }
    }
    .widget-body.chart {
      width: 100%;
      flex-grow: 1;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      .doughnutChartWrapper {
        height: inherit;
        > canvas {
          width: 10rem;
          height: 10rem;
          margin: 0 auto;
        }
      }
      .content {
        margin: 1rem 0;
        display: flex;
        align-items: center;
        gap: 1rem;
        dl {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          color: var(--text-secondary);
          > .chart-color {
            width: 0.75rem;
            height: 0.75rem;
            border-radius: 1rem;
          }
          > .chart-color.blue {
            background-color: var(--widget-status-blue);
          }
          > .chart-color.green {
            background-color: var(--widget-status-green);
          }
          > .chart-color.red {
            background-color: var(--widget-status-red);
          }
          > span > span.value {
            font-weight: 600;
            color: var(--text-primary);
          }
        }
      }
    }
    .widget-body.progressBar {
      width: 100%;
      flex-grow: 1;
      padding: 0 1rem;
      justify-content: space-between;
      margin-bottom: 1rem;
      > .progressBar-group {
        display: flex;
        flex-direction: column;
        > .progressBar-text {
          > span:nth-child(1) {
            color: var(--text-secondary);
          }
          > span:nth-child(2) {
            color: var(--text-primary);
          }
        }
        .fullBar {
          height: 2rem;
          border-radius: 1rem;
          margin-top: 0.25rem;
          overflow: hidden;
          display: flex;
          .fillBar {
            background-color: var(--widget-theme-darkblue);
            height: 100%;
          }
          .emptyBar {
            background-color: var(--widget-theme-darkblue);
            height: 100%;
            opacity: 0.35;
          }
        }
      }
      .content {
        width: 100%;
        font-size: 0.875rem;
        dl {
          gap: 0.5rem;
          > dt {
            color: var(--widget-text-secondary);
            font-weight: 600;
          }
        }
        dd {
          color: var(--widget-text-primary);
        }
        > div {
          > span {
            border-left: 1px solid var(--outline);
            padding: 0.5rem 0;
            margin: 0 0.5rem;
          }
          span.green {
            padding: 0.125rem 0.375rem;
            color: var(--widget-theme-darkblue);
            background-color: var(--widget-theme-tonal-darkblue);
            border-radius: 0.25rem;
          }
          span.blue {
            padding: 0.125rem 0.375rem;
            color: var(--widget-primary);
            background-color: var(--widget-theme-tonal-blue);
            border-radius: 0.25rem;
          }
        }
      }
    }
    .widget-body.donut {
      width: 100%;
      height: 100%;
      align-items: center;
      flex-direction: row;
      > .doughnutChartWrapper {
        overflow: hidden;
        /* height: 8rem; */
        padding: 0 1rem;
        margin-bottom: 1rem;
        width: 11rem;
        flex-shrink: 0;
      }
      > .content {
        flex: 1 1 auto;
        padding-right: 1rem;
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        padding-bottom: 2rem;
        dd,
        dt {
          font-size: 0.875rem;
          color: var(--widget-text-primary);
        }
        dl {
          gap: 0.5rem;
          padding: 0 0.25rem;
          > dt {
            color: var(--widget-text-secondary);
            font-weight: 600;
            gap: 0.5rem;
            div {
              width: 0.75rem;
              height: 0.75rem;
              border-radius: 1rem;
            }
            div.dot {
              background-color: var(--widget-theme-tonal-blue);
              display: flex;
              justify-content: center;
              align-items: center;
              > div {
                width: 0.25rem;
                height: 0.25rem;
                background-color: var(--widget-primary);
              }
            }
            div.fill {
              background-color: var(--widget-primary);
            }
            div.empty {
              background-color: var(--widget-primary);
              opacity: 0.25;
            }
          }
          > dd {
            gap: 0.25rem;
            span {
              padding: 0.125rem 0.375rem;
              color: var(--widget-primary);
              background-color: var(--widget-theme-tonal-blue);
              border-radius: 0.25rem;
              line-height: 1rem;
            }
          }
        }
        > dl:nth-child(1) {
          flex-direction: column;
          gap: 0.5rem;
          padding: 0;
          > dd:nth-child(2) {
            order: -999;
            gap: 0;
            font-size: 1.5rem;
            color: rgba(0, 0, 0, 0.6);
            span {
              font-size: 2rem;
              background-color: transparent;
              padding: 0 0.25rem;
            }
          }
        }
      }
    }
    .widget-body.table {
      width: 100%;
      flex-grow: 1;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      overflow: hidden;
      .thead {
        .tr > div {
          background-color: var(--widget-bg) !important;
        }
      }
      .tfoot {
        background-color: var(--widget-bg);
      }
      > div {
        height: 100%;
        .table {
          flex-grow: 1;
        }
      }
      .tr {
        pointer-events: none;
        .padding-right {
          padding-right: 1rem;
        }
        .tableStickyNo {
          padding-left: 1rem;
          font-weight: 600;
        }
        span.redLight {
          width: 2.125rem;
          height: 1.5rem;
          color: var(--filled-red);
          font-weight: 600;
          text-align: center;
          border-radius: 0.25rem;
          background-color: var(--tonal-red);
        }
        span.orangeLight {
          width: auto;
          height: 1.5rem;
          padding: 0 0.25rem;
          color: var(--filled-orange);
          font-weight: 600;
          text-align: center;
          border-radius: 0.25rem;
          background-color: var(--tonal-orange);
        }
        span.greenLight {
          width: 2.125rem;
          height: 1.5rem;
          color: var(--filled-green);
          font-weight: 600;
          text-align: center;
          border-radius: 0.25rem;
          background-color: var(--tonal-green);
        }
      }
      .tr.hover {
      }
    }
    .widget-body.graph {
      width: 100%;
      padding: 0 1rem;
      > div:nth-child(1) {
        width: 100%;
        > ul > li {
          width: 100%;
          max-width: none;
          > span {
            width: 100%;
          }
        }
      }
      > .lineChartWrapper {
        padding-bottom: 1rem;
      }
    }
    .widget-body.cctv-wide {
      flex-direction: row;
      gap: 0.5rem;
      padding: 0 1rem;
      height: 100%;
      overflow: hidden;
      > div:nth-child(2) {
        flex-grow: 1;
      }
      .cctvWrapper {
        border-radius: 0.25rem;
        padding: 0;
        > div {
          border-radius: 0;
        }
      }
      .controllerWrapper {
        border-radius: 0;
        background-color: transparent;
      }
      .controllerWrapper {
        .leftControl,
        .rightControl {
          display: none;
        }
        justify-content: center;
        .controllerBtn {
          padding: 0;
          width: 2rem;
          height: 2rem;
          color: var(--text-secondary);
        }
        .controllerBtn.activePage {
          border: none;
          color: var(--text-primary);
          background-color: var(--tonal-deep);
        }
      }
      .camListWrapper {
        display: flex;
        flex-direction: column;
        overflow: auto;
        flex-shrink: 0;
        margin-bottom: 1rem;
        background-color: var(--tonal);
        border-radius: 0.25rem;
        > button {
          height: 2.5rem;
          width: 10rem;
          padding: 0px 1rem;
          font-size: 0.875rem;
          justify-content: flex-start;
          flex-shrink: 0;
          font-weight: 500;
          display: block;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          text-align: left;
          &:hover {
            background-color: transparent;
          }
        }
        .active {
          background-color: transparent;
          border: none;
          color: rgba(0, 0, 0, 0.8);
        }
      }
    }
    .cameraLabel {
      font-size: 1rem !important;
    }
  }
  .cctv {
    .cctvWrapper,
    .controllerWrapper {
      max-height: 22rem;
      max-width: inherit;
    }
    .contents {
      > :first-child {
        padding-bottom: 1rem;
      }
    }
  }
  /* 현장 CCTV 뷰어 위젯 (CctvViewer - 1분할 / 다분할 공용) */
  .cctvNarrow {
    user-select: none;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    > .widget-header {
      width: 100%;
      padding: 0.75rem 1rem;
      flex-shrink: 0;
      > .widget-title {
        align-items: center;
        > span {
          font-weight: var(--font-semibold);
          font-size: 1.125rem;
          line-height: 1.2;
          color: var(--text-primary);
        }
        .refresh-btn {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 2rem;
          height: 2rem;
          border-radius: 2rem;
          .material-symbols-rounded {
            font-variation-settings: 'FILL' 1, 'wght' 300, 'GRAD' 0, 'opsz' 20;
            color: var(--text-tertiary);
            opacity: 0.6;
          }
          &:hover {
            background-color: var(--tonal);
            .material-symbols-rounded {
              opacity: 1;
            }
          }
        }
      }
    }
    .emptyData {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        max-width: 12rem;
        max-height: 12rem;
        object-fit: contain;
      }
      .main_text {
        padding: 1rem 1.5rem;
        background-color: var(--tonal);
        color: var(--text-secondary);
        border-radius: 0.5rem;
        margin: 0 1rem;
      }
    }
    .play-btn {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      border-radius: 0.5rem;
      background-color: var(--tonal);
      .material-symbols-rounded {
        font-size: 4rem;
        font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
        color: var(--text-tertiary);
        opacity: 0.6;
      }
      &:hover {
        background-color: var(--tonal-deep);
        .material-symbols-rounded {
          opacity: 1;
        }
      }
    }
    .widget-body.cctv-narrow {
      flex-grow: 1;
      padding: 0 1rem 1rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      overflow: hidden;
      > div:nth-child(1) > ul > li {
        width: 100%;
        max-width: none;
        span {
          width: 100%;
        }
      }
      .cctvWrapper {
        border-radius: 0.25rem;
        padding: 0;
      }
      .cameraLabel {
        display: none;
      }
      .controllerWrapper {
        display: none;
      }
    }
    .widget-body.cctv-grid {
      flex-grow: 1;
      padding: 0 1rem 1rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      overflow: hidden;
      .cctvWrapper {
        border-radius: 0.25rem;
        padding: 0;
      }
      .cameraLabel {
        display: none;
      }
      .controllerWrapper {
        border-radius: 0;
        background-color: transparent;
        /* 분할 수는 위젯별로 고정이므로 분할 버튼(좌)은 숨기고 페이지 이동(중앙)만 노출 */
        .leftControl,
        .rightControl {
          display: none;
        }
        justify-content: center;
        .controllerBtn {
          padding: 0;
          width: 2rem;
          height: 2rem;
          color: var(--text-secondary);
        }
        .controllerBtn.activePage {
          border: none;
          font-weight: 500;
          color: var(--text-primary);
          background-color: var(--tonal-deep);
        }
      }
    }
    .widget-body.cctv-view {
      flex: 1;
      min-height: 0;
      width: 100%;
      padding: 0;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      /* WebSdk의 <Root> 래퍼도 셀을 가득 채우도록 (영상 컨테이너의 부모) */
      > div {
        flex: 1;
        min-height: 0;
        width: 100%;
        display: flex;
        flex-direction: column;
      }
      /* WebSDK 영상 컨테이너가 위젯 셀 전체를 채우도록 */
      .cctvWrapper {
        flex: 1;
        min-height: 0;
        width: 100%;
        border-radius: 0.25rem;
        padding: 0;
      }
      /* 상황판 상시 노출 - 모든 조작 컨트롤 숨김 */
      .controllerWrapper {
        display: none;
      }
    }
  }
  .safetyMainPoint {
    overflow: hidden;
    height: 100%;
    .content {
      font-size: 3rem;
      height: inherit;
      width: 100%;
      .flow {
        height: inherit;
        text-align: center;
      }
      img {
        object-fit: contain;
        width: 100%;
        height: 100%;
      }
      .logoWrapper {
        width: 12rem;
        padding: 0 1.5rem;
        z-index: 2;
        background-color: var(--widget-bg);
        flex-shrink: 0;
      }
      .marquee {
        overflow: hidden;
        white-space: nowrap;
        flex-grow: 1;
        height: 100%;
        z-index: 1;
        white-space: nowrap;
        display: flex;
        align-items: center;
      }
      .marquee-content {
        display: inline-block;
        padding-left: calc(100% - 12rem);
      }
      @keyframes marquee {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-100%);
        }
      }

      .blink {
        animation: blinker 1s linear infinite;
      }

      @keyframes blinker {
        50% {
          opacity: 0;
        }
      }
    }
  }

  .tempImageBoard {
    > .widget-header {
      > .widget-title {
        padding: 0 1rem;
        align-items: center;
        > span {
          flex-shrink: 0;
          font-weight: var(--font-semibold);
          font-size: 1.125rem;
          line-height: 1.2;
          color: var(--text-primary);
          display: flex;
          align-items: center;
          > .badge {
            font-weight: 500;
            font-size: 0.875rem;
            padding: 0.125rem 0.5rem;
            border-radius: 0.25rem;
            background-color: var(--widget-theme-tonal-blue);
            margin: 0 0.5rem;
            color: var(--widget-primary);
            display: inline-block;
            min-width: 1.75rem;
            text-align: center;
          }
        }
      }
    }
    > .content {
      padding: 0 1rem 1rem 1rem !important;
      img {
        object-fit: cover !important;
        border-radius: 0.5rem;

        width: 100%;
        height: 100%;
        object-position: center; /* 중앙 정렬 (기본값) */
      }
    }
  }

  .imageBoard {
    height: 100%;
    .content {
      padding: 0;
      margin: 0;
      width: 100%;
      height: calc(100% - 3.5rem);
      flex-grow: 1;
      > div {
        height: 100%;
        .slick-list {
          height: inherit;
          div {
            height: 100%;
          }
        }
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
        margin: auto;
      }

      .slick-arrow {
        display: none !important;
      }

      .slick-dots {
        top: -2rem;
        width: inherit;
        right: 1rem;
        display: flex !important;
        gap: 0.5rem;
        li {
          margin: 0;
          width: 0.75rem;
          height: 0.75rem;
          border-radius: 0.25rem;
          button {
            width: 0.75rem;
            width: 24px;
          }
          button:before {
            transition: all ease-in-out 0.2s;
            font-family: 'slick';
            font-size: 15px;
            line-height: 20px;
            position: absolute;
            top: 0;
            left: 0;
            width: 12px;
            height: 12px;
            border-radius: 0.25rem;
            content: '';
            text-align: center;
            color: black;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            background-color: rgb(62, 151, 255);
          }
        }

        .slick-active {
          button:before {
            width: 16px;
            width: 24px;
          }
        }
      }
    }
  }

  .safetyViolationInfo {
    display: flex;
    flex-direction: column;
    .content {
      height: calc(100% - 4rem);

      .boxWrapper {
        height: calc(100% - 2rem);
        gap: 2rem;
        padding-top: 1rem;
      }

      .box {
        > div {
          text-align: end;
          span {
            color: rgb(63, 66, 84);
            font-size: 3rem;
          }
        }
        flex: 0.5;

        border-radius: 0.8rem;
        padding: 2rem;
        // text-align: center;
        background: rgb(243, 246, 249);
      }
    }
  }

  .accidentInfo {
    height: 100%;

    .content {
      display: flex;
      justify-content: space-evenly;
      gap: 0.25rem;

      .doughnutChartWrapper {
        width: 40%;
      }

      .chartContent {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 1rem;
      }

      dt,
      dd {
        font-size: 1.4rem;
      }

      dt {
        /* margin-right: 1rem; */
        display: flex;
      }
    }
  }

  .noxiousGas,
  .excavationProcess,
  .mGas {
    .doubleLine {
      line-height: 1rem;
      text-align: center;
    }

    .labelSet {
      > span {
        padding: 0 0.5rem;
        margin-left: 0.5rem;
      }
    }

    .textBox {
      font-size: 0.875rem;
      border-radius: 5px;
      /* border-radius: 1rem; */
      padding: 0 0.2rem;
      margin-left: 0.5rem;
    }

    .blue {
      color: var(--widget-status-blue) !important;
      background-color: var(--widget-status-tonal-blue) !important;
    }

    .red {
      color: var(--widget-status-red) !important;
      background-color: var(--widget-status-tonal-red) !important;
    }

    .violet {
      color: var(--filled-violet) !important;
      background-color: var(--tonal-violet) !important;
    }

    .orange {
      color: var(--filled-orange) !important;
      background-color: var(--tonal-orange) !important;
    }

    .green {
      color: var(--widget-status-green) !important;
      background-color: var(--widget-status-tonal-green) !important;
    }

    .amber {
      color: var(--widget-status-yellow) !important;
      background-color: var(--widget-status-tonal-yellow) !important;
    }

    .slate {
      color: var(--filled-slate) !important;
      background-color: var(--tonal) !important;
    }
  }

  .excavationProcess {
    .title,
    .content {
      width: 30%;
    }

    .textBox {
      border-radius: 5px;
      padding: 0 0.5rem;
    }

    .table .table > .tbody > .tr > * {
      height: 1.2rem;
      margin: 0.5rem 0;
    }
    /* CSS for the progress container */
    .progress-container {
      // width: 100%;
      height: 1.2rem;
      border: 0;
      position: relative;

      /* Styling the progress bar */
      progress {
        width: 100%;
        height: 100%;
        appearance: none;
        border-radius: 15px;
        background-color: rgba(80, 205, 137, 0.15);
      }

      /* Styling the uncompleted progress bar */
      progress::-webkit-progress-bar {
        background-color: rgba(80, 205, 137, 0.15); /* Uncompleted progress color */
        border-radius: 15px; /* Apply the same border radius as the progress element */
      }

      /* Styling the value (completed progress) */
      progress::-webkit-progress-bar {
        border-radius: 15px;
      }

      /* Styling the value (completed progress) */
      progress::-webkit-progress-value {
        background-color: rgba(80, 205, 137, 1);
        border-radius: 15px;
      }

      /* Styling the text inside the progress bar */
      .progress-text {
        text-align: center;
        font-size: 14px;
        line-height: 20px;
        color: white;
        background-color: #4caf50;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }

      .progressValue {
        position: relative;
        height: inherit;
        top: -26px;
        color: #fff;
      }
    }
  }

  .mGas {
    .mGasColumn > div {
      height: 2.25rem !important;
    }
    .thead {
      border-bottom: none;
      > :last-child {
        > div {
          border-right: 1px solid var(--outline-em);
        }
      }
      > .tr {
        border-bottom: 1px solid var(--outline);

        > div {
          padding: 0.5rem;
          text-align: center;
        }
      }
    }

    > .table {
      .thead {
        border-top: 1px solid var(--outline-em);
      }
      > div {
        padding: 1rem 0;
      }
    }
    .mGasColumn {
      &.stickyTd {
        position: sticky;
        left: 0;
        background-color: var(--board);
      }
      > div {
        border-bottom: 1px solid var(--outline);
        height: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
      }
    }
    .textLight {
      text-align: center;
      min-width: 3rem;
      font-size: 0.875rem;
      padding: 0 0.25rem;
      border-radius: 0.25rem;
      color: var(--text-primary);
    }
    .light {
      display: block;
      border-radius: 50%;
      background-color: transparent;
      font-size: 1.5rem;
    }
  }

  .mGas.tempEdit {
    .widget-header {
      padding-bottom: 0.5rem !important;
      margin-bottom: 0 !important;
      background-color: var(--widget-bg) !important;
    }
  }
`;

export { SiteDashboardStyle, DraggableCellStyle, DroppableCellStyle, ControlStyle };
